import { MapLocation } from '@/types/location';

export const hailDigitalMegacomScreens: MapLocation[] = [
  {
    id: 10077,
    name: "Digital Megacom Screen – Hail",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [27.480222, 41.724111],
    region: "Hail",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/de4ccd39-ca24-4182-9ae8-ac622a1eb981.png"
    }
  },
  {
    id: 10078,
    name: "Digital Megacom Screen – Hail 2",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [27.469500, 41.701750],
    region: "Hail",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/d10e7dd9-8b85-4168-a6ea-7d5567cceeac.png"
    }
  },
  {
    id: 10079,
    name: "Digital Megacom Screen – Hail 3",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [27.477417, 41.733306],
    region: "Hail",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/e120636d-4dd0-463f-9190-d88895858eb6.png"
    }
  },
  {
    id: 10080,
    name: "Digital Megacom Screen – Hail 4",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [27.480222, 41.702472],
    region: "Hail",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/98c4bb0b-551d-4225-81d1-6dd95418b4d7.png"
    }
  },
  {
    id: 10081,
    name: "Digital Megacom Screen – Hail 5",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [27.513944, 41.701361],
    region: "Hail",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/56ed0dde-dab0-4e44-a237-ffd8b8884a82.png"
    }
  }
];